export const SPELLS_BY_LEVEL_BLANK = {
    0: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    1: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    2: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    3: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    4: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    5: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    6: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    7: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    8: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
    9: {
        slots_total: '',
        slots_current: '',
        spells: []
    },
};
